<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">My Documents</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="showAddDocumentPopup()">
            <i class="fa fa-plus"></i>Add Document
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table Result -->
    <document-table
      :uploaderUserType="tokenObj.UserType"
      type="My Document"
      :userId="tokenObj.Id"
      :key="counter"
    ></document-table>
    <!-- /Table Result -->

    <!-- Add Document Modal -->
    <div class="modal custom-modal fade" id="addDocument" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <add-document
          @refreshData="refreshData"
          isFromUserDocument="true"
          :sourceUserId="tokenObj.Id"
          :key="counter"
        ></add-document>
      </div>
    </div>
    <!-- /Add Document Modal -->
  </div>
</template>

<script>
import config from "../../../config.js";
import DocumentTable from "../../Shared/DocumentTable.vue";
import AddDocument from "../../Shared/DocumentAdd.vue";
import $ from "jquery";
export default {
  components: {
    DocumentTable,
    AddDocument,
  },
  data() {
    return {
      counter: 0,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  methods: {
    showAddDocumentPopup() {
      $("#addDocument").modal("show");
    },
    refreshData() {
      $("#addDocument").modal("hide");
      this.counter++;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SchoolUser/Other/MyDocuments.vue